export const apiAdapter = ({ data }: any, locale: string) => {
  const attributes = data?.attributes;
  const choices = attributes?.questions?.map(
    (step: any) =>
      step?.choices?.map((choice: any) => choice?.children?.[0]?.text || "") ||
      []
  ) || [[], [], []];
  const steps = [
    {
      title:
        attributes?.questions?.[0]?.title ||
        (locale === "en"
          ? "Hi, let's get started! We need to know where in the world you are..."
          : "¡hola, Empecemos! Necesitamos saber en qué parte del mundo estás..."),
      description: "",
      choices: choices[0],
    },
    {
      title:
        attributes?.questions?.[1]?.title ||
        (locale === "en"
          ? "Tell us how much experience you have..."
          : "Contanos cuanta experiencia tenés..."),
      description: "",
      choices: choices[1],
    },
    {
      title:
        attributes?.questions?.[2]?.title ||
        (locale === "en"
          ? "the educational odyssey, what is your level?"
          : "la odisea educativa, ¿cuál es tu nivel?"),
      description: "",
      choices: choices[2],
    },
    {
      title:
        attributes?.final_form?.title ||
        (locale === "en" ? "last step!" : "¡último paso!"),
      applicantName:
        attributes?.final_form?.applicant_name_label ||
        (locale === "en" ? "Full name" : "Nombre completo"),
      email:
        attributes?.final_form?.email_label ||
        (locale === "en" ? "Email" : "Email"),
      emailError:
        attributes?.final_form?.email_error ||
        (locale === "en" ? "Invalid email" : "Email inválido"),
      description:
        attributes?.final_form?.comment ||
        (locale === "en"
          ? "Tell us something about yourself!"
          : "Contanos algo sobre vos!"),
      expected_income:
        attributes?.final_form?.expected_income_label ||
        (locale === "en"
          ? "Expected remuneration (arg peso)"
          : "Remuneración pretendida (Pesos)"),
      cv:
        attributes?.final_form?.cv_label ||
        (locale === "en" ? "Add your CV" : "Agregá tu CV"),
    },
    {
      title:
        attributes?.feedback?.title ||
        (locale === "en"
          ? "Great! We received your cv"
          : "¡Genial! recibimos tu cv"),
      description:
        attributes?.feedback?.description ||
        (locale === "en"
          ? "Thank you for applying! We will be in touch in the next few days. To kill the anxiety, we let you play with our Patux."
          : "¡Gracias por postularte! Nos vamos a comunicar en los próximos días. Para matar la ansiedad, te dejamos jugar con nuestro Patux."),
    },
  ];

  return { steps };
};
